const KEY = "svc_recs_v1"

function getStorage() {
    try {
        const data = JSON.parse(localStorage.getItem(KEY))

        if (!data || typeof data !== "object") {
            return {
                viewed: [],
                topPicks: [],
                best: [],
                collectionGroups: []
            }
        }

        return {
            viewed: Array.isArray(data.viewed) ? data.viewed : [],
            topPicks: Array.isArray(data.topPicks) ? data.topPicks : [],
            best: Array.isArray(data.best) ? data.best : [],
            collectionGroups: Array.isArray(data.collectionGroups) ? data.collectionGroups : []
        }
    } catch {
        return {
            viewed: [],
            topPicks: [],
            best: [],
            collectionGroups: []
        }
    }
}

function setStorage(data) {
    localStorage.setItem(KEY, JSON.stringify(data))
}

function uniqueById(items) {
    const map = new Map()

    items.forEach(item => {
        if (item && item.id && !map.has(item.id)) {
            map.set(item.id, item)
        }
    })

    return Array.from(map.values())
}

function addViewedProduct(product) {
    if (!product || !product.id) return

    const storage = getStorage()

    let items = storage.viewed.filter(item => item.id !== product.id)

    items.unshift(product)
    storage.viewed = items.slice(0, 20)

    setStorage(storage)
}

function getViewedProducts(limit = 8) {
    return getStorage().viewed.slice(0, limit)
}

function saveBestProducts(products) {
    if (!Array.isArray(products) || !products.length) return

    const storage = getStorage()

    if (!storage.best.length) {
        storage.best = uniqueById(products)
        setStorage(storage)
    }
}

function addCollectionGroup(products, currentProduct) {
    if (!Array.isArray(products) || !products.length) return
    if (!currentProduct || !currentProduct.id) return

    const storage = getStorage()

    const collectionHandle = currentProduct.collection || ""

    const groupItems = products
        .filter(item => item.id !== currentProduct.id)
        .filter(item => !collectionHandle || item.collection === collectionHandle)
        .slice(0, 4)

    if (!groupItems.length) return

    const newGroup = {
        collection: collectionHandle,
        items: groupItems
    }

    let groups = storage.collectionGroups.filter(group => group.collection !== collectionHandle)

    groups.unshift(newGroup)

    storage.collectionGroups = groups.slice(0, 3)

    setStorage(storage)
}

function rebuildTopPicks() {
    const storage = getStorage()

    const result = []
    const usedIds = new Set()

    storage.collectionGroups.forEach(group => {
        group.items.forEach(item => {
            if (result.length >= 12) return
            if (usedIds.has(item.id)) return

            result.push(item)
            usedIds.add(item.id)
        })
    })

    for (const item of storage.best) {
        if (result.length >= 12) break
        if (usedIds.has(item.id)) continue

        result.push(item)
        usedIds.add(item.id)
    }

    storage.topPicks = result.slice(0, 12)

    setStorage(storage)
}

function getTopPicks(limit = 12) {
    return getStorage().topPicks.slice(0, limit)
}

function initRecs() {
    if (!window.__PRODUCT_CARD_DATA__) return

    const product = window.__PRODUCT_CARD_DATA__

    addViewedProduct(product)

    if (window.__BEST_SELLERS_PRODUCTS__) {
        saveBestProducts(window.__BEST_SELLERS_PRODUCTS__)
    }

    if (window.__CURRENT_COLLECTION_PRODUCTS__) {
        addCollectionGroup(window.__CURRENT_COLLECTION_PRODUCTS__, product)
    }

    rebuildTopPicks()
}

document.addEventListener("DOMContentLoaded", () => {
    initRecs()
})

window.Recs = {
    viewed: getViewedProducts,
    topPicks: getTopPicks
}